import styled from "styled-components";

export const UserFormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`